exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-block {\n    margin-top: 10%;\n}\n\n.logo {\n    margin: auto;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.navbar-logo {\n    font-size: 40px;\n    margin-left: 0px;\n    color: #000;\n    font-family: Roboto-Medium;\n    letter-spacing: 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/auth/signin/signin.component.css
// module id = ../../../../../src/app/auth/signin/signin.component.css
// module chunks = main